export function renderRangeCell(rangeStableDate, currentRangeToDate, date, cellType) {
    const { start: rangeStart, end: rangeEnd } = getRangeBounds(rangeStableDate, currentRangeToDate);
    const compareFn = getDateComparator(cellType);
    const className = getRangeClassName(date, rangeStart, rangeEnd, compareFn);
    return { classes: className };
}
function getRangeBounds(rangeStableDate, currentRangeToDate) {
    if (rangeStableDate.getTime() < currentRangeToDate.getTime()) {
        return { start: rangeStableDate, end: currentRangeToDate };
    }
    return { start: currentRangeToDate, end: rangeStableDate };
}
function getDateComparator(cellType) {
    switch (cellType) {
        case 'day':
            return (date1, date2) => date1.isSameDay(date2);
        case 'month':
            return (date1, date2) => date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth();
        case 'year':
            return (date1, date2) => date1.getFullYear() === date2.getFullYear();
    }
}
function getRangeClassName(date, rangeStart, rangeEnd, compareFn) {
    if (compareFn(date, rangeEnd) && compareFn(date, rangeStart)) {
        return '-selected-';
    }
    if (compareFn(date, rangeStart)) {
        return '-selected- -range-from-';
    }
    if (compareFn(date, rangeEnd)) {
        return '-selected- -range-to-';
    }
    if (date.getTime() >= rangeStart.getTime() && date.getTime() <= rangeEnd.getTime()) {
        return '-in-range-';
    }
    return '';
}
